export default __webpack_public_path__ + "static/media/ic_upload_blue.c4d48408.svg";